module.exports = __webpack_public_path__ + "img/128.70d81c12.png";